export enum ResponseErrors {
  ACCESS_BLOCKED = 'USR00008',
  USER_UNAUTHORIZED = 'USR00012',
  TOKEN_EXPIRED = 'JWT00001',
  TOKEN_UNAUTHORIZED = 'TK00004',
  USER_NOT_FOUND = 'USR00010',
}
